import { usePathname } from "next/navigation";

import { fallbackLng, languages } from "@/i18n/settings";
import { AllowedLanguages } from "@/types/generic";

export const usePathnameLocale = () => {
  const pathname = usePathname();
  const lang = pathname?.split("/").filter(Boolean)?.[0] as AllowedLanguages;
  return languages.includes(lang) ? lang : fallbackLng;
};
